import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
/**
 * 単行テキスト入力カラム
 *【内容:content:string】
 *【プレースホルダ:placeholder:string】
 *【非活性:disabled:boolean】
 *【フォームコントロール名:formControl:FormControl】
 *【表示桁数:displayBytes:number】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-single-text-input-column',
  templateUrl: './single-text-input-column.html',
  styles: [`
    
  `]
})
export class SingleTextInputColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * フォームコントロール名
   */
  @Input() formControl:FormControl

  /**
   * 表示桁数
   */
  @Input() displayBytes:number

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  updateValue(event, index:number) {
    const value = event
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => event,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    if (this.content !== value) {
      this.records[index]['_changed'] = true
      this.on("change", index);
    }
    return event;
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/single-text-input-column/single-text-input-column.component.ts